const ssr = true;
const csr = true;
const prerender = false;
export {
  csr,
  prerender,
  ssr
};
//# sourceMappingURL=_layout.ts.js.map
